import { loader } from 'graphql.macro'

export default function invoicesAmountSummary ({ dataLoaders, queryKey }) {
  const [,
    haulerId,
    invoiceNumber = null,
    accountName = null,
    statuses = null,
    startDate = null,
    endDate = null
  ] = queryKey

  const summarySchema = loader('./invoicesAmountSummaryV2.graphql')
  return dataLoaders.dispatcher.graphQLClient.request(summarySchema, {
    haulerId,
    invoiceNumber,
    accountName,
    statuses: statuses ? (Array.isArray(statuses) ? statuses : [statuses]) : null,
    startDate,
    endDate
  })
}
